/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Checkbox, Col } from "antd";

export function FormCheckbox({ id, name, label, required, checked, ...rest }: any) {
  return (
    <Form.Item
      name={name}
      valuePropName="checked"
      rules={
        [
          // {
          //   validator: (_, value) =>
          //     required && !value
          //       ? Promise.reject(
          //           new Error(`Please accept ${label.toLowerCase()}`)
          //         )
          //       : Promise.resolve(),
          // },
        ]
      }
      layout="vertical"
    >
      <Col lg={6}>
      {label}
      </Col>
      <Col lg={6}>
      <Checkbox className="mt-2 pt-1" checked={checked} { ...rest}></Checkbox>
      </Col>
    </Form.Item>
  );
}
